import React from "react";
import LogoImg from '../../media/images/raidhiveLogo-nobg.png';
import bgVideo from '../../media/images/landingvideo.mp4';
import { StyledHeader, Nav, Logo, Container } from "./Header.styled";
import { Flex } from '../styles/Flex.styled'
import {ContentContainer, Tag, Title, Subtitle } from "../PageSection/PageSection.styled";
import { BackgroundVideo } from '../styles/Container.styled'
import { HeadingBgStyle } from "./Header.styled";
import { Card } from "@material-ui/core";
import SocialIcons from "../SocialIcons/SocialIcons";
import { UserAuth } from "../../utils/AuthContext";
import Account from './Account';


export const Header = () => {
    // const [active, setActive] = useState(false);
    const {user} = UserAuth();
    
    return (
        <StyledHeader>
            <Container>
                <Nav>
                    <Logo src={LogoImg} alt="" />
                    <SocialIcons/>
                    {user != null && <Account/>}
                </Nav>
            </Container>
            <HeadingBgStyle>
                <BackgroundVideo src={bgVideo} autoPlay loop muted />
                <ContentContainer>
                    <Flex>
                    <Card style={{ color: '#fff', backgroundColor: '#000', padding: '2em' }}>
                        <Tag>Whats the hype?</Tag>

                        <Title><b>Built for the community that thinks alike</b></Title>

                        <Subtitle>Raid to win. Watch to get entertain. Get it all</Subtitle>                        
                    </Card>                    
                    </Flex>
                </ContentContainer>
            </HeadingBgStyle>
        </StyledHeader>
    );
}